import { render, staticRenderFns } from "./RelatoriosAniversarioEquipesClientes.vue?vue&type=template&id=ee296082"
import script from "./RelatoriosAniversarioEquipesClientes.vue?vue&type=script&lang=js"
export * from "./RelatoriosAniversarioEquipesClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports